import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { TableHeader, TableRow } from 'components/table';
import PropTypes from 'prop-types';

import DataTableHeaderColumns from './DataTableHeaderColumns';

import './DataTableHeader.scss';

class DataTableHeader extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  static Columns = DataTableHeaderColumns;

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('data-table-header', className);

    return (
      <TableHeader className={classComponent}>
        {children ? children : this.renderDefault()}
      </TableHeader>
    );
  }

  renderDefault() {
    return (
      <TableRow>
        <DataTableHeaderColumns />
      </TableRow>
    );
  }
}

export default DataTableHeader;
